export enum ConfigEditorConfirmationPhase {
  First = 'First',
  Second = 'Second',
}

export interface ConfigEditorConfirmationDialogViewModel {
  confirmKey: string;
  title: string;
  warningText: string;
  actionText: string;
  endPhase?: ConfigEditorConfirmationPhase;
}
